import React from 'react'
import './Logo.sass'
import { NavHashLink } from 'react-router-hash-link'
import logo from './logoGrass.svg'
import scrollWithOffset from '../ScrollToTop/scrollWithOffset'

function Logo({ navLink = false, path }) {
  return navLink ? (
    <NavHashLink
      to={path}
      className="Logo"
      scroll={(el) => scrollWithOffset(el, -64)}
    >
      <img src={logo} alt="Gusto" />
    </NavHashLink>
  ) : (
    <a href={path} className="Logo">
      <img src={logo} alt="Gusto" />
    </a>
  )
}

export default Logo
